import { useState } from 'react';
import PageNavbar from '../../../components/feature/PageNavbar';
import Footer from '../../home/components/Footer';
import OnlineReferralModal from '../../home/components/OnlineReferralModal';

export default function VipProgramPage() {
  const [isReferralModalOpen, setIsReferralModalOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      <PageNavbar />

      {/* Hero Section */}
      <div className="relative bg-gradient-to-br from-teal-50 via-white to-emerald-50 py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="max-w-4xl">
            <div className="inline-block bg-teal-100 text-teal-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
              Intensive Recovery for Australian Veterans and Their Partners
            </div>
            <h1 className="text-5xl font-bold text-gray-900 mb-6 leading-tight">
              VIP – Veteran Intensive Program
            </h1>
            <p className="text-xl text-gray-700 leading-relaxed mb-8 italic">
              Rebuilding Strength. Restoring Connection. Renewing Purpose.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed max-w-3xl mb-8">
              Intensive Recovery for Australian Veterans and Their Partners
            </p>
            <p className="text-lg text-gray-600 leading-relaxed max-w-3xl">
              VIP is a 2–4 week intensive day or residential recovery program developed in conjunction with Veterans, for Veterans.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed max-w-3xl mt-4">
              It delivers coordinated medical, psychological and physical rehabilitation to restore function, confidence and direction following service-related trauma and complex health challenges
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-6 py-16">

        {/* Who It's For */}
        <section className="mb-24">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">Who It&rsquo;s For</h2>
          <ul className="space-y-3 max-w-3xl">
            <li className="text-lg text-gray-600 leading-relaxed">
              Australian Veterans managing PTSD, moral injury, depression, anxiety or chronic pain
            </li>
            <li className="text-lg text-gray-600 leading-relaxed">
              ADF personnel with complex neuropsychiatric presentations
            </li>
            <li className="text-lg text-gray-600 leading-relaxed">
              Veterans experiencing sleep disturbance, relationship strain or functional decline
            </li>
            <li className="text-lg text-gray-600 leading-relaxed">
              Partners seeking structured recovery and relationship rebuilding
            </li>
          </ul>
        </section>

        {/* What the Program Addresses */}
        <section className="mb-24">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">What the Program Addresses</h2>
          <p className="text-lg text-gray-600 leading-relaxed mb-6 max-w-3xl">
            VIP provides integrated treatment for:
          </p>
          <ul className="grid grid-cols-3 gap-x-8 gap-y-3 max-w-5xl">
            <li className="text-lg text-gray-600 leading-relaxed">PTSD and trauma-related disorders</li>
            <li className="text-lg text-gray-600 leading-relaxed">Moral injury</li>
            <li className="text-lg text-gray-600 leading-relaxed">Depression and anxiety</li>
            <li className="text-lg text-gray-600 leading-relaxed">Chronic pain</li>
            <li className="text-lg text-gray-600 leading-relaxed">Tinnitus and sensory sensitivity</li>
            <li className="text-lg text-gray-600 leading-relaxed">Sleep disturbance (CBT-I)</li>
            <li className="text-lg text-gray-600 leading-relaxed">Relationship and communication breakdown</li>
            <li className="text-lg text-gray-600 leading-relaxed">Functional and physical deconditioning</li>
            <li className="text-lg text-gray-600 leading-relaxed">Male and Female Sexual Disorders</li>
          </ul>
        </section>

        {/* What's Included */}
        <section className="mb-24">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">What&rsquo;s Included</h2>
          <p className="text-lg text-gray-600 leading-relaxed mb-6 max-w-3xl">
            Participants receive coordinated multidisciplinary care including:
          </p>
          <ul className="grid grid-cols-2 gap-x-8 gap-y-3 max-w-5xl mb-6">
            <li className="text-lg text-gray-600 leading-relaxed">Trauma-focused psychotherapies (CBT, EMDR, ACT)</li>
            <li className="text-lg text-gray-600 leading-relaxed">Pain management and graded exposure</li>
            <li className="text-lg text-gray-600 leading-relaxed">Physiotherapy and strength conditioning</li>
            <li className="text-lg text-gray-600 leading-relaxed">Vestibular rehabilitation (mTBI)</li>
            <li className="text-lg text-gray-600 leading-relaxed">Sleep optimisation (CBT-I)</li>
            <li className="text-lg text-gray-600 leading-relaxed">Psychoeducation modules</li>
            <li className="text-lg text-gray-600 leading-relaxed">Nutritional education</li>
            <li className="text-lg text-gray-600 leading-relaxed">Peer support and recovery coaching</li>
            <li className="text-lg text-gray-600 leading-relaxed">Complementary therapies</li>
            <li className="text-lg text-gray-600 leading-relaxed">Optional fitness and recreational training</li>
          </ul>
          <p className="text-lg text-gray-600 leading-relaxed max-w-3xl">
            Post-program telehealth and peer follow-up included.
          </p>
        </section>

        {/* How to Access */}
        <section className="mb-24">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">How to Access</h2>
          <div className="max-w-3xl">
            <ul className="space-y-3 mb-6">
              <li className="text-lg text-gray-600 leading-relaxed">Apply via www.activ.net.au</li>
              <li className="text-lg text-gray-600 leading-relaxed">DVA funding apply via (D1328 form)</li>
              <li className="text-lg text-gray-600 leading-relaxed">Assistance provided with funding documentation</li>
              <li className="text-lg text-gray-600 leading-relaxed">Referrals accepted from GPs, hospitals and veteran organisations</li>
              <li className="text-lg text-gray-600 leading-relaxed">6–8 week prior medical assessment required</li>
              <li className="text-lg text-gray-600 leading-relaxed">Programs run throughout the year (Day &amp; Residential).</li>
            </ul>
          </div>
        </section>

        {/* Location */}
        <section className="mb-24">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">Location</h2>
          <p className="text-lg text-gray-600 leading-relaxed max-w-3xl mb-4">
            Delivered through the{' '}
            <strong className="text-gray-900">Australian Centre for Trauma in Veterans (ACTIV)</strong>{' '}
            — a state-of-the-art multidisciplinary trauma recovery facility
          </p>
          <p className="text-lg text-gray-700 leading-relaxed max-w-3xl">
            154 Ipswich Road, Woolloongabba QLD 4102
          </p>
        </section>

        {/* Program Outline */}
        <section className="mb-24">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">Program Outline</h2>
          <p className="text-lg text-gray-600 leading-relaxed mb-6 max-w-3xl">
            The VIP daily structure integrates:
          </p>
          <ul className="space-y-3 max-w-3xl mb-6">
            <li className="text-lg text-gray-600 leading-relaxed">Trauma-informed strength and conditioning</li>
            <li className="text-lg text-gray-600 leading-relaxed">Group check-in and peer support</li>
            <li className="text-lg text-gray-600 leading-relaxed">Core evidence-based psychotherapy</li>
            <li className="text-lg text-gray-600 leading-relaxed">Specialty clinical modules</li>
            <li className="text-lg text-gray-600 leading-relaxed">Physical rehabilitation</li>
            <li className="text-lg text-gray-600 leading-relaxed">Psychoeducation</li>
            <li className="text-lg text-gray-600 leading-relaxed">Complementary therapies</li>
            <li className="text-lg text-gray-600 leading-relaxed">Optional recreation and structured evening reflection (residential)</li>
          </ul>
          <p className="text-lg text-gray-600 leading-relaxed max-w-3xl">
            Programs are adjusted to individual Veteran needs.
          </p>
        </section>

        {/* Program Guide */}
        <section className="mb-24">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">Program Guide</h2>
          <div className="overflow-x-auto">
            <table className="w-full border-collapse border border-gray-300 text-sm">
              <thead>
                <tr className="bg-gray-50">
                  <th className="border border-gray-300 px-3 py-3 text-left font-semibold text-gray-900">WEEK 1</th>
                  <th className="border border-gray-300 px-3 py-3 text-left font-semibold text-gray-900">MONDAY</th>
                  <th className="border border-gray-300 px-3 py-3 text-left font-semibold text-gray-900">TUESDAY</th>
                  <th className="border border-gray-300 px-3 py-3 text-left font-semibold text-gray-900">WEDNESDAY</th>
                  <th className="border border-gray-300 px-3 py-3 text-left font-semibold text-gray-900">THURSDAY</th>
                  <th className="border border-gray-300 px-3 py-3 text-left font-semibold text-gray-900">FRIDAY</th>
                  <th className="border border-gray-300 px-3 py-3 text-left font-semibold text-gray-900">SATURDAY</th>
                  <th className="border border-gray-300 px-3 py-3 text-left font-semibold text-gray-900">SUNDAY</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border border-gray-300 px-3 py-2.5 font-medium text-gray-900">8.00am</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Trauma Informed Strength &amp; Conditioning</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Trauma Informed Strength &amp; Conditioning</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Trauma Informed Strength &amp; Conditioning</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Trauma Informed Strength &amp; Conditioning</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Trauma Informed Strength &amp; Conditioning</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Trauma Informed Strength &amp; Conditioning</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Trauma Informed Strength &amp; Conditioning</td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="border border-gray-300 px-3 py-2.5 font-medium text-gray-900">8.30am</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Group Check in and Peer Support</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Group Check in and Peer Support</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Group Check in and Peer Support</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Group Check in and Peer Support</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Group Check in and Peer Support</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Group Check in and Peer Support</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Group Check in and Peer Support</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 px-3 py-2.5 font-medium text-gray-900">9.00am</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Core Therapy Session</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Core Therapy Session</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Core Therapy Session</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Core Therapy Session</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Core Therapy Session</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Core Therapy Session</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Core Therapy Session</td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="border border-gray-300 px-3 py-2.5 font-medium text-gray-900">10.10am</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">BREAK</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">BREAK</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">BREAK</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">BREAK</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">BREAK</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">BREAK</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">BREAK</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 px-3 py-2.5 font-medium text-gray-900">10.45am</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Specialty Clinical Session – Individualised to patients</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Specialty Clinical Session – Individualised to patients</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Specialty Clinical Session – Individualised to patients</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Specialty Clinical Session – Individualised to patients</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Specialty Clinical Session – Individualised to patients</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Specialty Clinical Session – Individualised to patients</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Specialty Clinical Session – Individualised to Veteran</td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="border border-gray-300 px-3 py-2.5 font-medium text-gray-900">12.00pm</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Lunch &amp; Social Engagement</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Lunch &amp; Social Engagement</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Lunch &amp; Social Engagement</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Lunch &amp; Social Engagement</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Lunch &amp; Social Engagement</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Lunch &amp; Social Engagement</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Lunch &amp; Social Engagement</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 px-3 py-2.5 font-medium text-gray-900">1.00pm</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Physical Rehabilitation Session</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Physical Rehabilitation Session</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Physical Rehabilitation Session</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Physical Rehabilitation Session</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Physical Rehabilitation Session</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Physical Rehabilitation Session</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Physical Rehabilitation Session</td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="border border-gray-300 px-3 py-2.5 font-medium text-gray-900">2.30pm</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">BREAK</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">BREAK</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">BREAK</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">BREAK</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">BREAK</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">BREAK</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">BREAK</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 px-3 py-2.5 font-medium text-gray-900">3.00pm</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Complimentary Therapies</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Complimentary Therapies</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Complimentary Therapies</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Complimentary Therapies</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Complimentary Therapies</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Complimentary Therapies</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Complimentary Therapies</td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="border border-gray-300 px-3 py-2.5 font-medium text-gray-900">4.00pm</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">BREAK</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">BREAK</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">BREAK</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">BREAK</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">BREAK</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">BREAK</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">BREAK</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 px-3 py-2.5 font-medium text-gray-900">4.15pm</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Group Psychoeducation</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Group Psychoeducation</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Group Psychoeducation</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Group Psychoeducation</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Group Psychoeducation</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Group Psychoeducation</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Group Psychoeducation</td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="border border-gray-300 px-3 py-2.5 font-medium text-gray-900">5.15pm</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Optional Fitness / Recreational Activity</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Optional Fitness / Recreational Activity</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Optional Fitness / Recreational Activity</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Optional Fitness / Recreational Activity</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Optional Fitness / Recreational Activity</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Optional Fitness / Recreational Activity</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Optional Fitness / Recreational Activity</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 px-3 py-2.5 font-medium text-gray-900">6.00pm</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">BREAK</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">BREAK</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">BREAK</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">BREAK</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">BREAK</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">BREAK</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">BREAK</td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="border border-gray-300 px-3 py-2.5 font-medium text-gray-900">6.30pm</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Dinner &amp; Social Engagement</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Dinner &amp; Social Engagement</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Dinner &amp; Social Engagement</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Dinner &amp; Social Engagement</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Dinner &amp; Social Engagement</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Dinner &amp; Social Engagement</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Dinner &amp; Social Engagement</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 px-3 py-2.5 font-medium text-gray-900">8.00pm</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Reflection &amp; Reset</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Reflection &amp; Reset</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Reflection &amp; Reset</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Reflection &amp; Reset</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Reflection &amp; Reset</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Reflection &amp; Reset</td>
                  <td className="border border-gray-300 px-3 py-2.5 text-gray-700">Reflection &amp; Reset</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        {/* Terms & Conditions */}
        <section className="mb-24">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">Terms &amp; Conditions</h2>
          <ul className="space-y-3 max-w-3xl">
            <li className="text-lg text-gray-600 leading-relaxed">Prior DVA approval required</li>
            <li className="text-lg text-gray-600 leading-relaxed">Accommodation and meals included (residential)</li>
            <li className="text-lg text-gray-600 leading-relaxed">Meals included (day program)</li>
            <li className="text-lg text-gray-600 leading-relaxed">Drug and alcohol-free environment</li>
            <li className="text-lg text-gray-600 leading-relaxed">Confidentiality strictly maintained</li>
            <li className="text-lg text-gray-600 leading-relaxed">Emergency and 24/7 support available</li>
            <li className="text-lg text-gray-600 leading-relaxed">Discharge plan and follow-up provided</li>
          </ul>
        </section>

        {/* Take the Next Step */}
        <section className="mb-16 max-w-3xl">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">Take the Next Step</h2>
          <p className="text-xl text-gray-700 leading-relaxed mb-2">
            Recovery is a journey.
          </p>
          <p className="text-xl text-gray-700 leading-relaxed mb-8">
            VIP provides the structure, discipline and support to move forward with strength.
          </p>
          <p className="text-lg text-gray-600 leading-relaxed mb-2">
            <strong className="text-gray-900">Website:</strong>{' '}
            <a
              href="https://www.activ.net.au"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="text-teal-700 font-semibold hover:underline cursor-pointer"
            >
              www.activ.net.au
            </a>
          </p>
          <p className="text-lg text-gray-600 leading-relaxed mb-8">
            <strong className="text-gray-900">Email:</strong>{' '}
            <a
              href="mailto:clinic@activ.net.au"
              className="text-teal-700 font-semibold hover:underline cursor-pointer"
            >
              clinic@activ.net.au
            </a>
          </p>
          <div className="flex flex-wrap gap-4">
            <button
              onClick={() => setIsReferralModalOpen(true)}
              className="inline-flex items-center gap-2 bg-gray-900 hover:bg-gray-800 text-white px-7 py-3.5 rounded-lg text-base font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              Online Referral
              <i className="ri-arrow-right-line"></i>
            </button>
            <a
              href="https://www.activ.net.au"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="inline-flex items-center gap-2 border border-gray-300 hover:border-gray-400 text-gray-700 px-7 py-3.5 rounded-lg text-base font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              Visit www.activ.net.au
              <i className="ri-external-link-line"></i>
            </a>
          </div>
        </section>

      </div>

      <Footer />

      <OnlineReferralModal
        isOpen={isReferralModalOpen}
        onClose={() => setIsReferralModalOpen(false)}
      />
    </div>
  );
}
